export default "__VITE_ASSET__D6$Ztxue__"